<template>
    <v-modal
        title="Seleccionar país"
        width="400"
        :visible="modalCountry"
        @close="$store.commit('modals/modalHandler', { name: 'modalCountry', boolean: false })"
    >
        <div class="modal-country">
            <router-link
                v-for="(out, inx) in countries"
                :key="inx"
                :class="country.code === out.code ? 'active' : ''"
                :to="`/${out.code.toLowerCase()}`"
                @click.native="$store.commit('modals/modalHandler', { name: 'modalCountry', boolean: false })"
            >
                <img :src="out.flag" :alt="out.name" />
                <span>{{ out.name }}</span>
            </router-link>
        </div>
    </v-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            countries: 'countries/countries',
            country: 'countries/country',
            modalCountry: 'modals/modalCountry'
        })
    }
}
</script>

<style lang="scss">
.modal-country {
    display: grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(2, 1fr);
    a {
        user-select: none;
        cursor: pointer;
        padding: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        border-radius: 4px;
        transition: all 0.4s;
        img {
            height: 30px;
            margin-bottom: 0.5rem;
            object-fit: contain;
        }
        span {
        }
        &:hover {
            background-color: #f3f3f3;
        }
        &.active {
            background-color: #e3e3e3;
            &:hover {
                background-color: #e3e3e3;
            }
        }
    }
}
</style>
